import { ContractManagementIcon } from "../Icon/contract-management";

export const PRODUCTS_MENU_LINKS = [
  {
    title: "Wallets",
    description: "Secure NFT wallets, easy asset management.",
    url: "/products/wallets",
    newTab: false,
    icon: (
      <img
        alt="mintable-wallet-icon"
        src={"/icons/mintable-wallet.svg"}
        className="w-8 h-8"
      />
    ),
  },
  {
    title: "Token Gating",
    description: "NFT access control, community engagement.",
    url: "/products/tokengating",
    newTab: false,
    icon: (
      <img
        alt="token-gating-icon"
        src={"/icons/token-gating.svg"}
        className="w-8 h-8"
      />
    ),
  },
  {
    title: "Tokenization",
    description: "Full NFT lifecycle tools: claimables, mint, and claim.",
    url: "/products/tokenization",
    newTab: false,
    icon: (
      <img
        alt="tokenization-icon"
        src={"/icons/tokenization.svg"}
        className="w-8 h-8"
      />
    ),
  },
  {
    title: "Generative NFTs",
    description: "Reward customers with engaging, redeemable digital assets.",
    url: "/products/generative-nfts",
    newTab: false,
    icon: (
      <img
        alt="generative-nfts-icon"
        src={"/icons/generative-nfts.svg"}
        className="w-8 h-8"
      />
    ),
  },
  {
    title: "Gasless Minting",
    description: "Employee tools for seamless NFT redemption and management.",
    url: "/products/gasless-minting",
    newTab: false,
    icon: (
      <img
        alt="gasless-minting-icon"
        src={"/icons/gasless-minting.svg"}
        className="w-8 h-8"
      />
    ),
  },
  {
    title: "Contract Management",
    description: "Cost-effective NFT transactions with zero gas fees.",
    url: "/products/contract-management",
    newTab: false,
    icon: (
      <ContractManagementIcon className="stroke-primary-400 hover:stroke-white transition-colors duration-200" />
    ),
  },
  {
    title: "Merchant App",
    description: "Cost-effective NFT transactions with zero gas fees.",
    url: "/products/merchant-app",
    newTab: false,
    icon: (
      <img
        alt="merchant-app-icon"
        src={"/icons/merchant-app.svg"}
        className="w-8 h-8"
      />
    ),
  },
];
